import type { SagaIterator } from "redux-saga";
import { call, fork, put, take } from "redux-saga/effects";
import { getType } from "typesafe-actions";

import * as originalSupplyApi from "@/shop/api/personalized/originalSupply";
import type { IPaperMachineInfo } from "@/shop/types/personalized/originalSupply";

import * as OriginalSupplyActions from "./actions";

function* fetchMachinesSaga(): SagaIterator {
  try {
    yield put(OriginalSupplyActions.fetchMachinesStart());
    const machines = (yield call(originalSupplyApi.fetchMachines)) as IPaperMachineInfo[];
    yield put(OriginalSupplyActions.fetchMachinesSuccess(machines));
  } catch (err) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
    yield put(OriginalSupplyActions.fetchMachinesFail(err));
  }
}

function* fetchMachinesOnceSaga(): SagaIterator {
  yield take(getType(OriginalSupplyActions.fetchMachines));
  yield fork(fetchMachinesSaga);
}

export default function* originalSupplySaga(): SagaIterator {
  yield fork(fetchMachinesOnceSaga);
}
